export function SilentRenewPage() {
    return null;
}
